import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Table, CardBox, EmptyState, Page } from '../../components';
import { retrieve } from '../../actions/organization-actions';
import { push } from '../../actions/nav-actions';
import { totalAnayatics } from '../../api';
import { Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import Modal from '../../components/Modal';


const MainPage = ({ user, retrieve, organizations,history }) => {

    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        totalAnayatics(
            user.token,
        ).then((res) => {
            setData(res)
            setLoading(false);
        }).catch((err) => {
            console.log(err);
            setLoading(false);
        });

    }
    , []);

    const [modal, setModal] = useState(false);

    const toggle = () => setModal(!modal);


  return (
    <Page title='Dashboard'>       
      <Modal
        visible={modal}
        onClose={toggle}
        title="Admin User Info"
        style={{ width: '100%' }}
      >
        <div className="row">
          <Table 
            data={data.adminUser}
            columns={[
              {
                Header: 'Name',
                accessor: 'name',
              },
              {
                Header: 'Email',
                accessor: 'email',
              },
           
              {
                Header: 'Username',
                accessor: 'username',
              },

            ]}
          />
        </div>
      </Modal>
        {
          loading ? <Loader /> :    <CardBox><div className='row'>
                    <div className='col-md-4 col-sm-6'>
            <Link to='/projects'>
            <div className='card'    style={{
                backgroundColor: '#70b3c5',
                color: '#ffff',
                width: '18rem',
                margin: '20px',
                padding: '10px',
                borderRadius: '10px',
                boxShadow: '0px 0px 10px 0px #000000',

              }}>
              <div className='card-body' style={
                {
                  textAlign: 'center',
                }
              } >
                <i className="fa fa-tasks fa-3x" aria-hidden="true" style={{
                  marginBottom: '10px',
                }}></i>
                <h1 className='card-text'>{data.projectCount}</h1>
                <h5 className='card-title'>Total Projects</h5>
              </div>
            </div>
            </Link>
          </div>
          {/* total project */}
          <div className='col-md-4 col-sm-6' onClick={() => history.push('/organizations')}>
            {/* <Link to='/organizations'> */}
            <div className='card' 
              style={{
                backgroundColor: '#70b3c5',
                color: '#ffff',
                width: '18rem',
                margin: '20px',
                padding: '10px',
                borderRadius: '10px',
                boxShadow: '0px 0px 10px 0px #000000',

              }}
            >
              <div className='card-body' style={
                {
                  textAlign: 'center',
                }
              }>
                {/* add icon */}
                <i className="fa fa-building fa-3x" aria-hidden="true" style={{
                  marginBottom: '10px',
                }}></i>
                <h1 className='card-text'>{data.organizationCount}</h1>
                <h5 className='card-title'>Total Organizations</h5>
              </div>
            </div>
            {/* </Link> */}
          </div> 
          {/* total org */}

          <div className='col-md-4 col-sm-6'>
            <Link to='/users'>
            <div className='card'    style={{
                backgroundColor: '#70b3c5',
                color: '#ffff',
                width: '18rem',
                margin: '20px',
                padding: '10px',
                borderRadius: '10px',
                boxShadow: '0px 0px 10px 0px #000000',
              }}>
              <div className='card-body' style={
                {
                  textAlign: 'center',
                }
              }>
                <i className="fa fa-users fa-3x" aria-hidden="true" style={{
                  marginBottom: '10px',
                }}></i>
                <h1 className='card-text'>{data.userCount}</h1>
                <h5 className='card-title'>Total Users</h5>
              </div>
            </div>
            </Link>
          </div>
          {/* total users */}
          <div className='col-md-4 col-sm-6'>
            <Link to='/resource-report' className='waves-effect waves-primary'>
            <div className='card'    style={{
                backgroundColor: '#70b3c5',
                color: '#ffff',
                width: '18rem',
                margin: '20px',
                padding: '10px',
                borderRadius: '10px',
                boxShadow: '0px 0px 10px 0px #000000',
              }}>
              <div className='card-body' style={
                {
                  textAlign: 'center',
                }
              }>
                <i className="fa fa-file fa-3x" aria-hidden="true" style={{
                  marginBottom: '10px',
                }}></i>

                <h1 className='card-text'>{data.resourceCount}</h1>
                <h5 className='card-title'>Total Resources</h5>
              </div>
            </div>
            </Link>
          </div>
          {/* total resource */}

          <div className='col-md-4 col-sm-6'>
            <Link to='/studycases'>
            <div className='card'    style={{
                backgroundColor: '#70b3c5',
                color: '#ffff',
                width: '18rem',
                margin: '20px',
                padding: '10px',
                borderRadius: '10px',
                boxShadow: '0px 0px 10px 0px #000000',

              }}>
              <div className='card-body' style={
                {
                  textAlign: 'center',
                }
              }>
                <i className="fa fa-book fa-3x" aria-hidden="true" style={{
                  marginBottom: '10px',
                }}></i>
                <h1 className='card-text'>{data.caseStudyCount}</h1>
                <h5 className='card-title'>Total Case Studies</h5>
              </div>
            </div>
            </Link>
          </div>
          {/* casestudy */}

    
          <div className='col-md-4 col-sm-6' onClick={
            () => {
              toggle();
            }         
          }>
            
            <div className='card'    style={{
                backgroundColor: '#70b3c5',
                color: '#ffff',
                width: '18rem',
                margin: '20px',
                padding: '10px',
                borderRadius: '10px',
                boxShadow: '0px 0px 10px 0px #000000',

              }}>
              <div className='card-body' style={
                {
                  textAlign: 'center',
                }
              }>
                <i className="fa fa-user fa-3x" aria-hidden="true" style={{
                  marginBottom: '10px',
                }}></i>
                <h1 className='card-text'>{data.adminUserCount}</h1>
                <h5 className='card-title'>Total Admin Users</h5>
              </div>
            </div>
          
          </div>
     
        </div>
        </CardBox>
        }



    
    </Page>
  );
};

const mapStateToProps = (state) => ({
  user: state.authReducer.user,
  organizations: state.organizations,
});

const mapDispatchToProps = (dispatch) => ({
  retrieve(token) {
    dispatch(retrieve(token));
  },
  push(routeName) {
    dispatch(push(routeName));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);


// WEBPACK FOOTER //
// ./src/routers/MainPage/index.js